"use client";

import { sileo, type SileoOptions } from "sileo";

/** Sileo omits `id` from public types, but createToast uses it for upsert. */
type WithId = SileoOptions & { id: string };

/** Sticky danger-time toast — must not share Sileo's default id with other dining toasts. */
export const DINING_DANGER_TOAST_ID = "dining-danger-time";

export function diningSileoAction(opts: WithId) {
  return sileo.action(opts as SileoOptions);
}

export function diningSileoSuccess(opts: WithId) {
  return sileo.success(opts as SileoOptions);
}

export function diningSileoError(opts: WithId) {
  return sileo.error(opts as SileoOptions);
}

export function diningSileoInfo(opts: WithId) {
  return sileo.info(opts as SileoOptions);
}
